import * as S from './LoginRelatedComponents.style';

const RedisLogo = () => {
  return <S.RedisLogoContainer />;
};

export default RedisLogo;
